"use strict";
/**
 * @description 全屏功能
 * @author xiaokyo
 */
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.setUnFullScreen = exports.setFullScreen = void 0;
var dom_core_1 = __importDefault(require("../../utils/dom-core"));
require("../../assets/style/full-screen.less");
var iconFullScreenText = 'w-e-icon-fullscreen'; // 全屏icon class
var iconExitFullScreenText = 'w-e-icon-fullscreen_exit'; // 退出全屏icon class
var classfullScreenEditor = 'w-e-full-screen-editor'; // 全屏添加至编辑器的class
/**
 * 设置全屏
 * @param editor 编辑器实例
 */
exports.setFullScreen = function (editor) {
    var $editorParent = dom_core_1.default(editor.toolbarSelector);
    var $textContainerElem = editor.$textContainerElem;
    var $toolbarElem = editor.$toolbarElem;
    var $iconElem = $toolbarElem.find("i." + iconFullScreenText);
    var config = editor.config;
    $iconElem.removeClass(iconFullScreenText);
    $iconElem.addClass(iconExitFullScreenText);
    $editorParent.addClass(classfullScreenEditor);
    $editorParent.css('z-index', config.zIndexFullScreen);
    $textContainerElem.css('height', '100%');
};
/**
 * 取消全屏
 * @param editor 编辑器实例
 */
exports.setUnFullScreen = function (editor) {
    var $editorParent = dom_core_1.default(editor.toolbarSelector);
    var $textContainerElem = editor.$textContainerElem;
    var $toolbarElem = editor.$toolbarElem;
    var $iconElem = $toolbarElem.find("i." + iconExitFullScreenText);
    var config = editor.config;
    $iconElem.removeClass(iconExitFullScreenText);
    $iconElem.addClass(iconFullScreenText);
    $editorParent.removeClass(classfullScreenEditor);
    $editorParent.css('z-index', 'auto');
    $textContainerElem.css('height', config.height + 'px');
};
/**
 * 初始化全屏功能
 * @param editor 编辑器实例
 */
var initFullScreen = function (editor) {
    // 当textSelector有值的时候，也就是编辑器是工具栏和编辑区域分离的情况， 则不生成全屏功能按钮
    if (editor.textSelector)
        return;
    if (!editor.config.showFullScreen)
        return;
    var $toolbarElem = editor.$toolbarElem;
    var $elem = dom_core_1.default("<div class=\"w-e-menu\">\n            <i class=\"" + iconFullScreenText + "\"></i>\n        </div>");
    $elem.on('click', function (e) {
        var $elemIcon = dom_core_1.default(e.currentTarget).find('i');
        if ($elemIcon.hasClass(iconFullScreenText)) {
            exports.setFullScreen(editor);
        }
        else {
            exports.setUnFullScreen(editor);
        }
    });
    $toolbarElem.append($elem);
};
exports.default = initFullScreen;
